module.exports = __webpack_public_path__ + "img/marker.4c986045.svg";